<div class="politica-cookies-modal" style="background: #ff4444; color: white; padding: 30px; border: 5px solid #ffff00; border-radius: 10px;">
  <h2 style="margin-top: 0; color: white;">🎉 MODAL MATERIAL FUNCIONANDO! 🎉</h2>
  <p style="font-size: 16px; line-height: 1.5;">
    <strong>Sucesso!</strong> O modal do Angular Material está funcionando perfeitamente!
  </p>
  <p style="font-size: 14px;">
    <strong>Data de teste:</strong> {{ dataAtualizacao }}
  </p>
  
  <div style="margin-top: 20px;">
    <button mat-raised-button color="primary" (click)="close()" style="margin-right: 10px;">
      ✅ Fechar Modal
    </button>
  </div>
</div> 